// extracted by mini-css-extract-plugin
module.exports = {"container":"DevTools_container__e4Sgw","info":"DevTools_info__3i5Db","languageSelection":"DevTools_languageSelection__PVG72"};